module.exports = __webpack_public_path__ + "resources/img/solution_game_logo_ateam_m.231195b16fbfe10ea31d4871a806d9ff.png";